import { useMapPagePresenter } from '@Map/FloorMap/Components/MapPage/MapPagePresenter';
import { MapGridDepartment } from '@Map/shared/MapGridDepartment';
import { observer } from 'mobx-react-lite';
import React from 'react';

export type MapGridProps = {
  onPress?: (departmentId: number) => void;
  cellSize: number;
  gapSize?: number;
  borderRadius?: number;
};
export const MapGrid = observer(function MapGrid(props: MapGridProps) {
  const { currentFloor } = useMapPagePresenter();

  return (
    <>
      {currentFloor?.departments.map((dep) => (
        // TODO: remove these pass through props
        <MapGridDepartment department={dep} {...props} key={dep.departmentId} />
      ))}
    </>
  );
});
